import React, { useEffect, useState } from 'react';
import { FaInfoCircle } from 'react-icons/fa';
import './Status.css';

function Status() {
  const [loading, setLoading] = useState(true);
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    // Simulate loading
    const loadingTimer = setTimeout(() => {
      setLoading(false);
      setShowError(true);
    }, 2000); // 2 second fake loading

    return () => clearTimeout(loadingTimer);
  }, []);

  if (loading) {
    return (
      <div className="status-page">
        <div className="container">
          <div className="status-header">
            <h1>Product Status</h1>
            <p>Real-time status of all our products</p>
          </div>
          <div className="loading">
            <div className="spinner"></div>
            <p>Loading product status...</p>
          </div>
        </div>
      </div>
    );
  }

  if (showError) {
    return (
      <div className="status-page">
        <div className="container">
          <div className="status-header">
            <h1>Product Status</h1>
            <p>Real-time status of all our products</p>
          </div>

          <div className="status-notice card">
            <div className="notice-icon"><FaInfoCircle /></div>
            <div className="notice-content">
              <h3>No Products Available</h3>
              <p>Unable to retrieve product status. No products are currently configured. Check back soon or join our Discord for updates.</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return null;
}

export default Status;
